import React, { useContext } from 'react';
import { AuthContext } from './../AuthContext';
import { site_url_img} from "./../config.js";
import { useNavigate } from "react-router-dom";
import { isStaffUser } from './../role.js';

const closeSidebar = () => {
  const modalEl = document.getElementById('sidebarPanel');
  document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
  document.body.classList.remove('modal-open');
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
  if (modalEl) {
    modalEl.classList.remove('show');
    modalEl.style.display = '';
    modalEl.setAttribute('aria-hidden', 'true');
    modalEl.removeAttribute('aria-modal');
  }
};

export default function Index() {
    const navigate = useNavigate();
    const { fulluser, user, setUser, logout } = useContext(AuthContext);
    const staffLogin = isStaffUser(fulluser);

    const goTo = (path) => (e) => {
      e.preventDefault();
      closeSidebar();
      navigate(path);
    };

    const handleLogout = (e) => {
      e.preventDefault();
      closeSidebar();
      if (logout) {
        logout();
      } else {
        localStorage.removeItem('access_token');
        localStorage.removeItem('jwt_token');
        localStorage.removeItem('role');
        localStorage.removeItem('staff_id');
        localStorage.removeItem('user_id');
        setUser('');
      }
      localStorage.removeItem('mpin');
      sessionStorage.setItem("mpin_verified", "false");
      navigate("/");
    };

  return (
    <><div className="appHeader bg-primary text-light">
    <div className="left">
      <a
        href="#"
        className="headerButton"
        data-bs-toggle="modal"
        data-bs-target="#sidebarPanel"
      >
        <ion-icon name="menu-outline" />
      </a>
    </div>
    <div className="pageTitle" style={{ position: 'absolute', left: '56px', right: '10px', minWidth: 0, overflow: 'hidden', padding: '0 8px', textAlign: 'left' }}>
     <h4
      title={`Welcome ${fulluser?.shop_name || user}`}
      style={{color:'white',fontWeight:'700',fontSize:'18px',margin:0,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}
     >
      Welcome {fulluser?.shop_name || user}
     </h4>
    </div>
    <div className="right"></div>
  </div>
    <div
    className="modal fade panelbox panelbox-left"
    id="sidebarPanel"
    tabIndex={-1}
    role="dialog"
  >
    <div className="modal-dialog" role="document">
      <div className="modal-content">
        <div className="modal-body p-0">
          <div className="profileBox pt-2 pb-2">
            <div className="image-wrapper">
              {fulluser && fulluser.shop_img != '' && (
              <img
                src={site_url_img+'/'+fulluser.shop_img}
                alt="image"
                className="imaged  w36"
              />
              )}
            </div>
            {fulluser && (
            <div className="in">
              <strong>
                {fulluser.is_staff
                  ? `${fulluser.staff_name || fulluser.username} (Staff)`
                  : `${fulluser.username}-${fulluser.id}`}
              </strong>
              <div className="text-muted">{fulluser.phone}</div>
             {!fulluser.is_staff && fulluser.gst != '' && (<strong>{fulluser.gst}</strong>)}
            </div>
            )}
            <a
              href="#"
              className="btn btn-link btn-icon sidebar-close"
              data-bs-dismiss="modal"
            >
              <ion-icon name="close-outline" />
            </a>
          </div>
          <div className="listview-title mt-1">Menu</div>
          <ul className="listview flush transparent no-line image-listview">
            <li>
            <a href="/home" className="item" onClick={goTo('/home')}>
                <div className="icon-box bg-primary">
                  <ion-icon name="pie-chart-outline" />
                </div>
                <div className="in">Overview</div>
              </a>
            </li>
            {!staffLogin && (
            <li>
            <a href="/Product" className="item" onClick={goTo('/Product')}>
                <div className="icon-box bg-primary">
                  <ion-icon name="document-text-outline" />
                </div>
                <div className="in">Product</div>
              </a>
            </li>
            )}
            {!staffLogin && (
            <li>
            <a href="/Staff" className="item" onClick={goTo('/Staff')}>
                <div className="icon-box bg-primary">
                  <ion-icon name="people-outline" />
                </div>
                <div className="in">Staff</div>
              </a>
            </li>
            )}
            {!staffLogin && (
            <li>
            <a href="/SalesReport" className="item" onClick={goTo('/SalesReport')}>
                <div className="icon-box bg-primary">
                  <ion-icon name="stats-chart-outline" />
                </div>
                <div className="in">Sales Report</div>
              </a>
            </li>
            )}
            <li>
            <a href="/StaffReport" className="item" onClick={goTo('/StaffReport')}>
                <div className="icon-box bg-primary">
                  <ion-icon name="bar-chart-outline" />
                </div>
                <div className="in">{staffLogin ? 'My Report' : 'Staff Report'}</div>
              </a>
            </li>
            <li>
            <a href="/Transaction" className="item" onClick={goTo('/Transaction')}>
                <div className="icon-box bg-primary">
                  <ion-icon name="card-outline" />
                </div>
                <div className="in">My Transaction</div>
              </a>
            </li>
          </ul>
          <div className="listview-title mt-1">Others</div>
          <ul className="listview flush transparent no-line image-listview">
            <li>
            <a href="/Settings" className="item" onClick={goTo('/Settings')}>
                <div className="icon-box bg-primary">
                  <ion-icon name="settings-outline" />
                </div>
                <div className="in">Settings</div>
              </a>
            </li>
            <li>
              <a href="#logout" onClick={handleLogout} className="item">
                <div className="icon-box bg-primary">
                  <ion-icon name="log-out-outline" />
                </div>
                <div className="in">Log out</div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  </>
  )
}
